export const primary = '#1976d2';
export const negative = '#f3216bff';